import { install as dataItemExtensionInstall } from './dataItem';

export function install(registers) {
  dataItemExtensionInstall(registers);
}
